// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import PopupPanel from '../components/popupPanel/PopupPanel';
import PopupBoardSectionFocusManager from '../components/popupPanel/PopupBoardSectionFocusManager';
import PoiBoardSectionContext from '../components/pointsOfInterest/PoiBoardSectionContext';
import PopupList from '../components/popupPanel/types/PopupList';
import OrchestratedList from '../list/OrchestratedList';
import SelectionMarquee from '../canvas/selection/SelectionMarquee';
import List from '../list/List';
import ContextMenuManager from '../workspace/contextMenu/ContextMenuManager';

// Decorators
import selectionMarqueeListDecorator from '../canvas/selection/selectionMarqueeListDecorator';
import { zoomStateContextConsumer } from '../canvas/zoom/ZoomStateContext';

// Actions
import { refreshIfModified } from '../element/board/boardService';

// Constants
import { ELEMENT_DEFAULT_WIDTH } from '../../common/elements/elementConstants';
import { IN_LIST_MODE } from '../../common/inList/listTypes';
import { WORKSPACE_SECTIONS } from '../workspace/workspaceConstants';

// Utils
import { getListChildNewLocation } from '../../common/elements/utils/elementLocationUtils';

// Styles
import './SidebarPopupContent.scss';

const INITIAL_RENDER_SIZE = 10;

const mapDispatchToProps = (dispatch) => ({
    dispatchRefreshIfModified: (rootId) => dispatch(refreshIfModified({ boardId: rootId })),
});

@selectionMarqueeListDecorator
@zoomStateContextConsumer
@connect(null, mapDispatchToProps)
class SidebarPopupContent extends React.Component {
    componentWillMount() {
        const { dispatchRefreshIfModified, rootId } = this.props;
        dispatchRefreshIfModified(rootId);
    }

    componentWillUnmount() {
        const { saveElementRenderState } = this.props;
        saveElementRenderState();
    }

    render() {
        const {
            childIds,
            rootId,
            popupClassName,
            popupId,
            gridSize,
            setSelectionMarqueeActive,
            setListContainerNode,
            listContainerNode,
            listElementProps,
            getInitialElementsVisibility,
            elementPlaceholderMeasurements,
            listCanDropFn,
        } = this.props;

        const initialElementsVisibility = getInitialElementsVisibility(childIds);

        const getLocation = (event, props) => {
            const { rootId } = props;
            return getListChildNewLocation({ listId: rootId });
        };

        return (
            <PopupPanel
                {...this.props}
                popupId={popupId}
                ignoredClicksSelector=".SelectionToolList,.Breadcrumb,.Board,.Alias,.ContextMenu"
                className={classNames(popupClassName, { empty: childIds.length === 0 })}
                closeOnMouseUp
            >
                <PopupBoardSectionFocusManager
                    section={WORKSPACE_SECTIONS.QUICK_NOTES}
                    childElementIds={childIds}
                    ignoredClicksSelector=".ContextMenu"
                >
                    <ContextMenuManager
                        menuId="sidebar-popup-menu"
                        className="SidebarPopupContextMenuManager"
                        getLocation={getLocation}
                        isEditable={true}
                        {...this.props}
                    >
                        <PopupList>
                            <PoiBoardSectionContext.Provider value={WORKSPACE_SECTIONS.QUICK_NOTES}>
                                <SelectionMarquee
                                    sectionElementIds={childIds}
                                    setSelectionMarqueeActive={setSelectionMarqueeActive}
                                    eventListenerNode={listContainerNode}
                                    containerWidth={gridSize * (ELEMENT_DEFAULT_WIDTH + 3.9)}
                                    gridSize={gridSize}
                                    disabled={childIds.length === 0}
                                />
                                <OrchestratedList initialRenderSize={INITIAL_RENDER_SIZE} childElementIds={childIds}>
                                    {(childElementIds, listSize) => (
                                        <List
                                            {...this.props}
                                            listContainerRef={setListContainerNode}
                                            childElementIds={childElementIds}
                                            listSize={listSize}
                                            listId={rootId}
                                            currentBoardId={rootId}
                                            inListClass={IN_LIST_MODE.IN_LIST_QUICK_NOTES}
                                            isEditable
                                            listCanDropFn={listCanDropFn}
                                            listElementProps={{
                                                ...listElementProps,
                                                initialElementsVisibility,
                                                elementPlaceholderMeasurements,
                                            }}
                                        />
                                    )}
                                </OrchestratedList>
                            </PoiBoardSectionContext.Provider>
                        </PopupList>
                    </ContextMenuManager>
                </PopupBoardSectionFocusManager>
            </PopupPanel>
        );
    }
}

SidebarPopupContent.propTypes = {
    rootId: PropTypes.string,
    childIds: PropTypes.array,
    currentUser: PropTypes.object,
    selectedElementIds: PropTypes.object,
    currentlyEditingId: PropTypes.string,
    popupClassName: PropTypes.string,
    popupId: PropTypes.string,
    dispatchRefreshIfModified: PropTypes.func,
    gridSize: PropTypes.number,
    setSelectionMarqueeActive: PropTypes.func,
    listCanDropFn: PropTypes.func,
    setListContainerNode: PropTypes.func,
    listContainerNode: PropTypes.object,
    listElementProps: PropTypes.object,
    elementPlaceholderMeasurements: PropTypes.object,
    saveElementRenderState: PropTypes.func,
    getInitialElementsVisibility: PropTypes.func,
};

export default SidebarPopupContent;
